import {  Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';

export interface DialogData {
    title: string;
    text: string;
    list?: string[];
    value: string;
    type: string;
}

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    imports: [
        MatInputModule,
        TranslatePipe,
        MatFormFieldModule,
        MatIconModule,
        ReactiveFormsModule,
        FormsModule
    ]
,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class DialogComponent implements OnInit {
    text_yes?: string;
    text_no?: string;
    button_save?: string;
    button_cancel?: string;

    constructor(
        public dialogRef: MatDialogRef<DialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
    ) {
    }

    ngOnInit() {
        this.text_yes = 'yes';
        this.text_no = 'no';
        this.button_save = 'next';
        this.button_cancel = 'cancel';
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    onClick(): void {
        this.dialogRef.close(this.data.value);
    }
}
